import React, { useContext, useEffect, useState } from 'react';
import Game from '../../components/Game';
import Score from '../../components/Score';
import Walkthrough from '../../components/Walkthrough';
import * as constants from '../../constants/constants';
import AppContext from '../../context/AppContext';
import Levels, { LevelInfo } from '../../levels/levels';
import { GC } from '../../services/config/gamecentreService';
import { storage } from '../../services/config/storage';
import GameApi, { logError } from '../../services/game';
import './Play.scss';
import Tutorial from '../../components/Tutorial/Tutorial';

const Play = () => {

    const { context, setContext, timer, setTimer, header,showTutorial, setShowTutorial } = useContext(AppContext);
    const [currentLevel, setCurrentLevel] = useState(0);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [score, setScore] = useState([]);
    const [wt, setWt] = useState([0, 0]);
    const [loopOnce, setLoopOnce] = useState(false);
    const [data, setData] = useState({});
    const [showLevelWalkthrough, setShowLevelWalkthrough] = useState(false);
    const [isUpdating, setIsUpdating] = useState(true);

    const onClick = (value, startTime) => {
        const quesObj = Levels[currentLevel][currentQuestion];
        if (value.toString() == Levels[currentLevel][currentQuestion].specs.answer.toString()) {
            setScore([...score, {
                points: 25,
                level: currentLevel,
                question: currentQuestion,
                time: (startTime - timer) ? startTime - timer : 1,
                timeAtAnswer: timer,
            }]);
        }
        else {
            const currentTotalScore = score.reduce((acc, cv) => acc + cv.points, 0);
            if ((currentTotalScore - 10) < 0) {
                setScore([...score, {
                    points: 0,
                    level: currentLevel,
                    question: currentQuestion,
                    time: startTime - timer,
                    timeAtAnswer: timer,
                }]);
            }
            else {
                setScore([...score, {
                    points: -10,
                    level: currentLevel,
                    question: currentQuestion,
                    time: startTime - timer,
                    timeAtAnswer: timer,
                }]);
            }

        }

        if (loopOnce || ((currentQuestion + 1) >= Levels[currentLevel].length)) {
            setLoopOnce(true);
            let nextQuestion = parseInt(Math.random() * 100) % Levels[currentLevel].length;
            if (Levels[currentLevel].length > 0) {
                while (nextQuestion == currentQuestion) {
                    nextQuestion = parseInt(Math.random() * 100) % Levels[currentLevel].length
                }
            }
            setTimeout(() => {
                setCurrentQuestion(nextQuestion);
            }, 200);
        }
        else {

            setTimeout(() => {
                setCurrentQuestion(currentQuestion + 1);
            }, 200);
        }
    }

    const onSaveData = async (currentLevel) => {
        if (currentLevel === undefined || currentLevel === null) {
            return;
        }
        const currentLevelScore = score.filter(s => s.level == currentLevel);
        let min = -1;
        let mistakeIndex = 0;
        currentLevelScore.forEach((s, index) => {
            if (s.timeAtAnswer > min && (s.points == -10 || s.points == 0)) {
                mistakeIndex = index;
                min = s.timeAtAnswer;
            }
        });
        const scoresBeforeMistake = currentLevelScore.slice(0, mistakeIndex);
        const scoresAfterMistake = currentLevelScore.slice(mistakeIndex + 1);

        const payload = {
            "gameData": {
                "levelData": [
                    {
                        "level": currentLevel + 1,
                        "totalTime": 60,
                        isLevelCleared: true,
                        "totalMoves": currentLevelScore.length,
                        "averageMoveTime": (currentLevelScore.reduce((ac, cv) => ac + cv.time, 0) / currentLevelScore.length).toFixed(2),
                        "correctMoves": currentLevelScore.filter(cs => cs.points > 0).length,
                        "incorrectMoves": currentLevelScore.filter(cs => cs.points == 0 || cs.points == -10).length,
                        "pointScored": currentLevelScore.reduce((ac, cv) => ac + cv.points, 0),
                        "stateOfFlow": "",
                        "comment": "",
                        "action": "",
                        "mood": "",
                        "timeBeforeStart": wt[currentLevel],
                        "firstMistakeMove": mistakeIndex ? mistakeIndex + 1 : null,
                        averageMoveTimeBeforeMistake: scoresBeforeMistake.length && ((scoresBeforeMistake.reduce((ac, cv) => ac + (cv.time || 0), 0) / scoresBeforeMistake.length).toFixed(2)),
                        averageMoveTimeAfterMistake: ((scoresAfterMistake.reduce((ac, cv) => ac + cv.time, 0) / scoresAfterMistake.length).toFixed(2)),
                    },
                ],
                "totalLevelCleared": currentLevel + 1,
                "totalTimeTaken": "90",
            }
        };
        GC.sendGameDataSaveMessage(payload);

    }

    const getGameData = () => {
        const gameData = storage.get.levelData();
        if (gameData) {
            const currentLevel = gameData.totalLevelCleared ?? 0;
            setCurrentLevel(currentLevel >= constants.TOTAL_LEVELS ? null : currentLevel);
            setContext({
                ...context,
                currentLevel: currentLevel >= constants.TOTAL_LEVELS ? null : LevelInfo[currentLevel]?.chapter,
            });
            setShowLevelWalkthrough(currentLevel < constants.TOTAL_LEVELS);
        } else {
            setShowLevelWalkthrough(true);  
        }
        setData({ gameData });
        setIsUpdating(false)
    }

    const getAccuracy = () => {

        let totalMoves = score.length;
        let correctMoves = score.filter(s => s.points > 0).length;
        data?.gameData?.levelData?.forEach(level => {
            totalMoves = totalMoves + level.totalMoves;
            correctMoves = correctMoves + level.correctMoves;
        });
        correctMoves = correctMoves / (totalMoves);
        return correctMoves ? correctMoves * 100 : 0;
    }

    const getScore = () => {
        let finalScore = score.reduce((acc, cval) => acc + cval.points, 0);
        data?.gameData?.levelData?.forEach(level => {
            finalScore = finalScore + level.pointScored;
        });
        return finalScore ? finalScore : 0;
    }

    const setWalkthroughTime = (wtTime) => {
        const newWt = [...wt];
        newWt[currentLevel] = wtTime;
        setWt(newWt);
    }

    useEffect(() => {
        console.log("LEVEL: ", currentLevel, isUpdating);
        if (currentLevel !== null && !isUpdating) {
            setShowLevelWalkthrough(true);
            setLoopOnce(false);
        }
        if (currentLevel === null && !isUpdating) {
            onSaveData();
        }
    }, [currentLevel])

    useEffect(() => {
        if (timer === undefined) {
            return;
        }
        else if (timer === null && currentLevel != null) {
            onSaveData(currentLevel);
            if ((currentLevel + 1) >= Levels.length) {
                setCurrentLevel(null);
                setContext({
                    ...context,
                    currentLevel: null,
                })
            }
            else {
                setCurrentLevel(currentLevel + 1);
                setContext({
                    ...context,
                    currentLevel: LevelInfo[currentLevel + 1].chapter,
                })
            }
        }
    }, [timer]);

    useEffect(() => {
        getGameData()
    }, [])

    const onTutorialStart = () => {
        setShowLevelWalkthrough(false);
        setShowTutorial(true);
    }

    const onLevelStart = () => {
        setShowLevelWalkthrough(false);
        setShowTutorial(false);
        setCurrentQuestion(0);
        setTimer(constants.GAME_TIME);
    }

    return isUpdating ? null : (
        <div className={`Play ${!header && 'no-overlay'}`}>
            {Levels[currentLevel]?.[currentQuestion] && timer >= 0 && !showLevelWalkthrough && !showTutorial ?
                <Game
                    loopOnce={loopOnce}
                    onClick={onClick}
                    question={Levels[currentLevel][currentQuestion]}
                    timer={timer}
                    currentQuesNo={currentQuestion}
                />
                : null
            }
            {showTutorial ?
                <Tutorial onEnd={() => onLevelStart()} currentLevel={currentLevel} /> : null
            }
            {currentLevel == null ?
                <Score
                    timeTaken={getScore()}
                    score={getAccuracy()}
                />
                :
                null
            }
            {showLevelWalkthrough ?
                <Walkthrough
                    levelInfo={LevelInfo[currentLevel]}
                    onClick={onTutorialStart}
                    gameTitle={LevelInfo[currentLevel]?.name}
                    description={LevelInfo[currentLevel]?.description}
                    setWalkthroughTime={setWalkthroughTime}
                />
                :
                null
            }
        </div>
    );
}

export default Play;